// src/Components/NicheShared/NicheCTA.tsx
import React from "react";
import styled from "styled-components";
import Container from "../Container";
import ButtonTestFree from "../ButtonTestFree";

interface NicheCTAProps {
  phrase: string;
}

const Phrase = styled.h2`
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const NicheCTA: React.FC<NicheCTAProps> = ({ phrase }) => (
  <Container
    style={{
      paddingTop: "80px",
      paddingBottom: "80px",
      background: "#6125e5",
      textAlign: "center",
    }}
  >
    <Phrase>{phrase}</Phrase>
    <ButtonTestFree />
  </Container>
);

export default NicheCTA;
